// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-default.section-default--partners .sections{display:flex;flex-direction:column;flex-wrap:wrap;justify-content:center;padding:0 10px;width:100%}@media(min-width:767px){.section-default.section-default--partners .sections{flex-direction:row}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
